module.exports = __webpack_public_path__ + "static/img/team_member_vivi.1421accc.png";